'use client'

import { useState } from 'react'
import { Icon } from '@iconify/react/dist/iconify.js'

// A plain password <input> with the standard show/hide eye toggle — reused
// across Sign In, Sign Up and Reset Password (the only places this app
// collects a password) instead of duplicating the toggle logic three times.
// Takes every normal <input> prop; type is fixed internally (toggled between
// 'password' and 'text'), so passing one has no effect. paddingRight is set
// inline rather than appended to className, since Tailwind's utility order
// in the generated stylesheet — not the order written in the class string —
// decides which padding utility wins, so an appended px override can't be
// relied on to beat the caller's own px-* class.
export default function PasswordInput({ className, style, ...props }: Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>) {
  const [visible, setVisible] = useState(false)
  return (
    <div className='relative'>
      <input {...props} type={visible ? 'text' : 'password'} className={className} style={{ ...style, paddingRight: '2.75rem' }} />
      <button type='button' onClick={() => setVisible(v => !v)} tabIndex={-1}
        aria-label={visible ? 'Hide password' : 'Show password'}
        className='absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors'>
        <Icon icon={visible ? 'mdi:eye-off-outline' : 'mdi:eye-outline'} width={20} />
      </button>
    </div>
  )
}
